var map = {
	"./alipay.jpg": "nnlQ",
	"./balance.png": "7iao",
	"./bank_abc.gif": "MaoN",
	"./bank_bea.gif": "7psL",
	"./bank_bjrcb.gif": "3yCn",
	"./bank_bob.gif": "eBNj",
	"./bank_boc.gif": "GKTH",
	"./bank_bosc.gif": "rXN7",
	"./bank_cbhb.gif": "9LWa",
	"./bank_ccb.gif": "aPTv",
	"./bank_ceb.gif": "LHZC",
	"./bank_cib.gif": "IKJJ",
	"./bank_citic.gif": "yB1Q",
	"./bank_cmb.gif": "jggY",
	"./bank_cmbc.gif": "XG0f",
	"./bank_comm.gif": "nrRE",
	"./bank_czb.gif": "NCDN",
	"./bank_gdb.gif": "yecy",
	"./bank_gzcb.gif": "KBlT",
	"./bank_hsb.gif": "xdfV",
	"./bank_hxb.gif": "aPbQ",
	"./bank_hzb.gif": "Oy5H",
	"./bank_icbc.gif": "thUx",
	"./bank_nbcb.gif": "/9xT",
	"./bank_njcb.gif": "+95X",
	"./bank_pab.gif": "s7eN",
	"./bank_psbc.gif": "X0K3",
	"./bank_sdb.gif": "l81D",
	"./bank_spdb.gif": "id9I",
	"./bank_srcb.gif": "/dTY",
	"./recharge.png": "0YxO",
	"./unionpay.jpg": "YC/B",
	"./unionpay_online.gif": "NZbn",
	"./wechatpay.jpg": "spP+",
	"./wecompay.png": "Rxd/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KoSa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank ^\.\/.*$
// module id = KoSa
// module chunks = 0